import { FileUp } from 'lucide-react';
import { useTranslation } from 'react-i18next';
import { Link, useNavigate } from 'react-router';
import { Button } from '@/components/ui/button';
import type { RowAction } from '@/components/ui/row-actions-menu';
import { EXPENSES_MANAGE, holds, useExpensesPermissions } from '../use-expenses-permissions';

/** The list header's «Importa da nexpense»: offered only to holders of `expenses:expense:manage`. */
export function ImportReferenceLink() {
  const { t } = useTranslation('expenses');
  if (!holds(useExpensesPermissions(), EXPENSES_MANAGE)) return null;
  return (
    <Button asChild variant="outline">
      <Link to="/expenses/import">{t('import.link')}</Link>
    </Button>
  );
}

/** «Importa da nexpense» as a «···» menu item (the phone); empty without the manage permission. */
export function useImportAction(): readonly RowAction[] {
  const { t } = useTranslation('expenses');
  const navigate = useNavigate();
  const manages = holds(useExpensesPermissions(), EXPENSES_MANAGE);
  if (!manages) return [];
  return [
    {
      id: 'import',
      label: t('import.link'),
      icon: FileUp,
      onSelect: () => void navigate('/expenses/import'),
    },
  ];
}
